import React from "react";
import "./About.css";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import img1 from "../photos/guri_amir.webp";
import img2 from "../photos/bibihonim1.webp";
import img3 from "../photos/ulugbek_observatoriyasi.webp";

const About = () => {
    const { t } = useTranslation();

    return (
        <main className="about-page">

            <Helmet>
                <title>{t("about.seo_title")}</title>
                <meta name="description" content={t("about.seo_desc")} />
            </Helmet>

            <section className="about-section">

                {/* LEFT */}
                <div className="about-left">

                    <h1 className="about-title">
                        🌍 {t("about.title")}
                    </h1>

                    <p className="about-text">
                        <strong>✨ {t("about.block_1_strong_1")}</strong>
                        {t("about.block_1_text_1")}
                        <strong> 🏆 {t("about.block_1_strong_2")}</strong>
                    </p>

                    <p className="about-text">
                        {t("about.block_2_text_1")}
                        <strong> 💡 {t("about.block_2_strong")}</strong>
                        {t("about.block_2_text_2")}
                    </p>

                    <p className="about-text">
                        🌅 {t("about.block_3_text")}
                    </p>

                    <p className="about-text">
                        👥 {t("about.block_4_text_1")}
                        <strong> 🧭 {t("about.block_4_strong")}</strong>
                        {t("about.block_4_text_2")}
                    </p>

                    <p className="about-text">
                        📈 {t("about.block_5_text")}
                    </p>

                    <h2 className="about-heading">
                        ⭐ {t("about.why_title")}
                    </h2>

                    <ul className="about-list">
                        <li>🏅 {t("about.list_1")}</li>
                        <li>🗺️ {t("about.list_2")}</li>
                        <li>🌍 {t("about.list_3")}</li>
                        <li>🤝 {t("about.list_4")}</li>
                        <li>⭐ {t("about.list_5")}</li>
                    </ul>

                    <p className="about-text">
                        🏕️ {t("about.block_6_text")}
                    </p>

                    <p className="about-text">
                        ❤️ {t("about.block_7_text")}
                    </p>

                    <button
                        className="about-gold-btn"
                        onClick={() => window.location.href = "/contact"}
                    >
                        📩 {t("about.contact_btn")}
                    </button>

                    <p className="about-text">
                        ✈️ {t("about.block_8_text")}
                    </p>

                    <p className="about-text">
                        🧳 {t("about.block_9_text")}
                    </p>

                    <p className="about-text">
                        🏨 {t("about.block_10_text")}
                    </p>

                    <p className="about-text">
                        🌟 {t("about.block_11_text")}
                    </p>

                </div>

                {/* RIGHT */}
                <div className="about-right">

                    <div className="about-image-card">
                        <img src={img1} alt={t("about.img1_alt")} />
                        <p className="about-image-caption">
                            📍 {t("about.img1_caption")}
                        </p>
                    </div>

                    <div className="about-image-card">
                        <img src={img2} alt={t("about.img2_alt")} />
                        <p className="about-image-caption">
                            🏛️ {t("about.img2_caption")}
                        </p>
                    </div>

                    <div className="about-image-card">
                        <img src={img3} alt={t("about.img3_alt")} />
                        <p className="about-image-caption">
                            🔭 {t("about.img3_caption")}
                        </p>
                    </div>

                </div>

            </section>

        </main>
    );
};

export default About;